import { classNames } from 'libs/react';
import { Text } from 'components/Text';
import { React } from 'libs/react';
import { normalizeColor } from 'helpers/primaryColor';
import './Status.scss';
/**
 * Colour names with a dedicated style (anything else is read as a hex value).
 */
const NAMED_COLORS = [
    'red',
    'green',
    'blue',
    'orange',
    'yellow',
    'pink',
    'purple',
    'gray',
    'light-gray'
];
/**
 * @component Status
 * @since 1.0.0
 */
export function Status(props) {
    const { style, label, color } = Object.assign({ style: 'normal' }, props);
    // Stage colours are free hex values: draw the dot with it directly
    const custom = NAMED_COLORS.includes(color) ? null : normalizeColor(color);
    const className = classNames('status', 'status--' + style, custom ? 'status--custom' : 'status--' + color, props.className);
    return (React.createElement("div", { className: className, style: custom
            ? { '--status-dot': custom }
            : undefined },
        React.createElement(Text, { className: "status-label", value: label })));
}
